import { render, staticRenderFns } from "./suppliersCard.vue?vue&type=template&id=ef21f08a&"
import script from "./suppliersCard.vue?vue&type=script&lang=js&"
export * from "./suppliersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports